module.exports = __webpack_public_path__ + "img/flag-gray.3d2366a3.svg";